const medications = [
  "blood_thinners",
  "bisphosphonates",
  "ibuprofen",
  "levothyroxine",
  "pantoprazole",
  "metamizole",
  "ramipril",
  "metoprolol",
  "bisoprolol",
  "simvastatin",
  "amlodipine",
  "diclofenac"
];
export {
  medications
};
